<template>
  <div
    :style="{ order: this.options.position }"
    v-indicator="{ id, setActive }"
    :class="[
      `herospark-banner_${id}`,
      'w-100 d-flex justify-content-center align-items-center flex-wrap py-3',
      { active: isActive(id) },
    ]"
  >
    <div class="information">
      {{ $i18n.t('components.page-editor.herospark-banner.info') }}
      <i class="fas fa-hand-pointer" @click.stop="setActive(id)"></i>
    </div>
    <span class="text pr-1">{{ $i18n.t('components.page-editor.herospark-banner.built') }}</span>
    <a :href="heroLink">
      <HeroSpark />
    </a>
  </div>
</template>

<script>
import Mixin from './Mixin'
import HeroSpark from '@/assets/herospark.svg'

export default {
  mixins: [Mixin],
  components: { HeroSpark },
  data() {
    return {
      heroLink: 'https://herospark.com/',
    }
  },
}
</script>

<style lang="scss" scoped>
[class^='herospark-banner_'] {
  position: relative;
  background-color: #262626;

  > .information {
    display: none;
    position: absolute;
    bottom: 0px;
    right: 0px;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    z-index: 200;
    background: var(--indicator-active);
    cursor: pointer;
  }

  &:hover,
  &.active {
    box-shadow: inset 0 0 0px 2px var(--indicator-active);
    > .information {
      display: block;
    }
  }
}

.text {
  font-family: Muli;
  line-height: 150%;
  font-size: 14px;
  color: #ffffff;
}
</style>
